<template>
  <div
    class="container"
    :style="{ background: $route.name == 'download' ? '#f8f8f8' : '#ffffff' }"
  >
    <div class="con">
      <div class="t list-container">
       
      </div>
      <div class="m list-container">
        <div class="list-item">鹏源药业</div>
        <div>普宁市池尾街道华市村新华里22幢第9层</div>
      </div>
      <div class="b list-container">
        <div>
          Copyright © 2017-2020
          <a class="beian" href="https://beian.miit.gov.cn/" target="_blank">粤ICP备20060288号-1</a>
          版权所有 客服电话：0663-2297239、2297005
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState} from 'vuex'

export default {
  computed:{
    ...mapState('sessionData',['baseInfo','navbar']),
    info(){
      return this.baseInfo
    },
    toplist(){
      return this.navbar.bottomNavigations
    }
  },
  methods: {
    tourl(item) {
      /*
          none(0, "无链接"),
          goods_detail(1, "商品详情"),
          goods_keyword(2, "商品关键字"),
          combination_detail(3, "套餐详情"),
          combination_tag(4, "套餐标签"),
          special(5, "限时特价"),
          article(6, "文章");
        */
      if (item.type == 6) {
        this.$router.push({ name: "helpcenter", query: { id: item.content } });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.beian {
  color: #999999 !important;
}
.beian:hover {
  color: #ff3e3e !important;
}
.container {
  height: 110px;
  background: #ffffff;
  overflow: hidden;
  border-top: 1px solid #fafafa;
  .con {
    text-align: center;
  }
  .list-container {
    font-size: 14px;
    color: #999999;
    display: flex;
    justify-content: center;
    .list-item {
      margin-right: 10px;
      padding-right: 10px;
      position: relative;
      &::after {
        content: "";
        width: 2px;
        background: #999999;
        height: 10px;
        display: block;
        @include abs-y-c;
        right: 0;
      }
    }
  }
  .t {
    margin: 20px 0 14px;
  }
  .m {
    margin-bottom: 16px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/plugins/foot-component.vue